import { Routes } from '@angular/router';
import { ProductsComponent } from './feature-products/src/lib/products/products.component';
import { productsGuard } from './guard/src/lib/products.guard';

export const PRODUCTS_ROUTES: Routes = [
  {
    path: '',
    component: ProductsComponent,
    title: 'Nebula ERP - Productos',
    data: {
      showSidebar: false,
      showHeader: true,
      showBreadcrumb: false,
      showFooter: false,
    },
    canActivate: [productsGuard],
  },
];
